
//import {BrowserRouter, Routes, Route} from 'module'

import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ChangePassword from "./components/dashboard/ChangePassword";
import Chats from "./components/dashboard/Chats";
import Index from "./components/dashboard/Index";
import MyOrders from "./components/dashboard/MyOrders";
import OrderDetails from "./components/dashboard/OrderDetails";
import WishList from "./components/dashboard/WishList";
import UseLoadCustomerFromCookie from "./components/SwitchLogin";
import About from "./pages/About";
import BlogDetails from "./pages/BlogDetails";
import Blogs from "./pages/Blogs";
import Card from "./pages/Card";
import CategoryShops from "./pages/CategoryShops";
import ConfirmOrder from "./pages/ConfirmOrder";
import Contact from "./pages/Contact";
import Dashboard from "./pages/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Payment from "./pages/Payment";
import ProduitsDetails from "./pages/ProduitsDetails";
import Register from "./pages/Register";
import SearchProduct from "./pages/SearchProduct";
import SellOnGobymall from "./pages/SellOnGobymall";
import Shipping from "./pages/Shipping";
import Shops from "./pages/Shops";
import VerificationOtp from "./pages/VerificationOtp";
import { setCustomerInfo } from "./store/reducers/authReducer";
//import './utils/i18n';
import ProtectUser from "./utils/ProtectUser";




function App() {
  const dispatch = useDispatch();
 

useEffect(() => {
    const token = localStorage.getItem("customerToken");
    if (token) {
        try {
            const customerInfo = jwtDecode(token);
            if (customerInfo.otp === null) {
                dispatch(setCustomerInfo(customerInfo));
            } else {
                // Si le compte n’est pas vérifié, on enlève tout
                localStorage.removeItem("customerToken");
                dispatch(setCustomerInfo(null));
                //toast.error("Veuillez vérifier votre compte.");
                //navigate("/verify/account");
            }
        } catch (err) {
            localStorage.removeItem("customerToken");
            dispatch(setCustomerInfo(null));
           // toast.error("Token invalide.");
        }
    }
}, [dispatch]);


  return (
   <BrowserRouter>
    <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/forgotPassword" element={<ForgotPassword/>} />
        <Route path="/register" element={<Register/>} />
        <Route path="/shops" element={<Shops/>} />
        <Route path="/products?" element={<CategoryShops/>} />
        <Route path="/products/search" element={<SearchProduct/>} />
        <Route path="/card" element={<Card/>} />
        <Route path="/shipping" element={<Shipping/>} />
        <Route path="/sell_on_gobymall" element={< SellOnGobymall/>} />
       
        <Route path="/product/details/:productId" element={<ProduitsDetails/>} />
        <Route path="/payment" element={<Payment/>} />
        <Route path='/order/confirm?' element={<ConfirmOrder />} />
        <Route path='/contact' element={<Contact/>} />
        <Route path='/about' element={<About/>} />
        <Route path='/blogs' element={<Blogs/>} />
        <Route path="/blog/blogdetails/:blogId" element={<BlogDetails/>} />

        <Route path="/verify/account" element={<VerificationOtp/>} />
        <Route path="/switch-login?" element={<UseLoadCustomerFromCookie/>} />


        <Route path="/dashboard" element={<ProtectUser />}>
            <Route path='' element={<Dashboard/>}>
                <Route path="" element={<Index/>} />
                <Route path="my_orders" element={<MyOrders/>} />
                <Route path="my_wishlist" element={<WishList/>} />
                <Route path="my_chats" element={<Chats/>} />
                <Route path="my_chats/:sellerId" element={<Chats/>} />
                <Route path="order/details/:orderId" element={<OrderDetails/>} />
                <Route path="change_password" element={<ChangePassword/>} />
            </Route>
        </Route>
    </Routes>
   </BrowserRouter>
  );
}

export default App;
